import React, { FunctionComponent } from 'react';
import { View } from 'react-native';
import { Svg, Path } from 'react-native-svg';

import { Color } from '~/components/color';

import { IconProps } from './icon-types';

export const ButtonForwardIcon: FunctionComponent<IconProps> = ({ fill, size = 24 }) => {
    return (
        <View style={{ width: size, height: size }}>
            {/* @ts-ignore see https://github.com/react-native-svg/react-native-svg/issues/1471 */}
            <Svg accessible={false} viewBox="0 0 24 24" focusable={false} tabIndex="-1">
                <Path
                    d="M20 12L3 12"
                    strokeWidth={2}
                    stroke={fill ?? Color.ALMOST_BLACK}
                    // @ts-ignore
                    tabIndex="-1"
                />
                <Path
                    d="M14 6L20 12L14 18"
                    strokeWidth="2"
                    strokeLinecap="round"
                    fill={Color.TRANSPARENT}
                    stroke={fill ?? Color.ALMOST_BLACK}
                />
            </Svg>
        </View>
    );
};
